<template>
  <div>
    <el-timeline class="my-timeline">
      <el-timeline-item v-for="(item, index) in timeline" :key="index" :icon="'user-photo-'+item.type" size="large" :class="'item-process item-process-'+(operatorStatus(item.type,item.descInfo).line)">
        <!-- 发起人 -->
        <template v-if="item.type==='START'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name">{{item.userInfo}}</span>
            </div>
            <div class="status suc">发起审批</div>
          </div>
          <div class="operator-time">{{item.createTime}}</div>
          <div class="comment" v-if="item.content">{{item.content}}</div>
          <div class="user-icon i-suc"></div>
        </template>
        <!-- 已撤销 -->
        <template v-if="item.type==='REVOKE'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name">{{item.userInfo}}</span>
            </div>
            <div class="status">已撤销</div>
          </div>
          <div class="operator-time">{{item.createTime}}</div>
          <div class="user-icon i-cancel"></div>
        </template>
        <!-- 转交 -->
        <template v-if="item.type==='TRANSFER'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name">{{item.userInfo}}</span>
            </div>
            <div v-if="item.operatorId" class="status">转交</div>
          </div>
          <div v-if="item.transferUser" class="transfer-user">{{item.transferUser}}</div>
          <div class="operator-time">{{item.createTime}}</div>
          <div class="comment" v-if="item.content">
            <template v-if="item.operatorId">{{item.content}}</template>
            <template v-else>
              <span class="err">未找到{{item.nodeName}}</span>，已自动转交给 {{ item.newUser }}
            </template>
          </div>
          <div v-if="item.operatorId" class="user-icon i-zhuanjiao"></div>
          <div v-else class="user-icon i-zidong"></div>
        </template>
        <!-- 前后加签 -->
        <template v-if="item.type==='SIGN'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name">{{item.userInfo}}</span>
            </div>
            <div class="status">添加审批人</div>
          </div>
          <div class="transfer-user">{{item.signUser}}</div>
          <div class="operator-time">{{item.createTime}}</div>
          <div class="comment" v-if="item.content">{{item.content}}</div>
          <div class="user-icon i-suc"></div>
        </template>
        <!-- 评论 -->
        <template v-if="item.type==='COMMENT'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name">{{item.userInfo}}</span>
            </div>
            <div class="status suc">评论</div>
          </div>
            <div class="operator-time">{{item.createTime}}</div>
          <div class="comment" v-if="item.content">
            {{item.content}}
            <div class="img-list" v-if="item.imageUrls &&  item.imageUrls.length>0">
              <div class="item-img" v-for="(src,key) of item.imageUrls" :key="key">
                <img  :src="src" class="img" width="80" height="80">
                <span class="preview-bg" @click="handlePictureCardPreview(src)">
                  <i class="el-icon-zoom-in"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="user-icon i-comment"></div>
        </template>
          <!-- 审批人 一个 -->
          <template v-if="item.type==='APPROVE'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name">{{ item.userInfo }}</span>
              <!-- 前后加签标记 -->
                <span v-if="item.signText" class="suc">{{ item.signText }}</span>
            </div>
            <div :class="['status',operatorStatus(item.type,item.descInfo).class]">{{operatorStatus(item.type,item.descInfo).text}}</div>
          </div>
          <div class="operator-time">{{item.createTime || item.nowTime}}</div>
          <div class="comment" v-if="item.content">
            <template v-if="item.noUser">
              <span class="err">未找到审批人</span>，{{ item.noUserText }}</template>
            <template v-else>{{item.content}}</template>
          </div>
          <div :class="['user-icon ','i-'+operatorStatus(item.type,item.descInfo).class]"></div>
        </template>
        <!-- 审批人 会签 多人 -->
        <template v-if="item.type==='MULTI_APPROVE'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name">{{ item.userCount }}人{{item.mode}}</span>
            </div>
            <div :class="['status',operatorStatus(item.type,item.descInfo).class]">{{operatorStatus(item.type,item.descInfo).text}}</div>
          </div>
          <div  class="user-con">
            <template v-if="!item.showAll">
                <span v-for="(person,index2) of item.userInfo.slice(0,6)" :key="index2">
                  {{person.name}}
                  <template v-if="index2 !== 5">、</template>
                </span>
              <span class="more suc" @click="item.showAll = true">查看全部&gt;</span>
            </template>
            <template v-else>
              <span v-for="(person,index2) of item.userInfo" :key="index2">
                  {{person.name}}
                  <template v-if="index2 != +item.userCount-1">、</template>
                </span>
            </template>
          </div>
          <div class="operator-time">{{item.createTime || item.nowTime}}</div>
          <div :class="['user-icon ','i-'+operatorStatus(item.type,item.descInfo).class]"></div>
        </template>
        <!-- 或签抄送 多人 -->
        <template v-if="item.type==='ORSIGNCC'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              
              <span class="user-name">抄送或签{{ item.userCount }}人
                <span :class='item.read.color'>({{item.read.text}})</span>
              </span>
            </div>
          </div>
          <div  class="user-con">
            <template v-if="!item.showAll">
                <span v-for="(person,index2) of item.userInfo.slice(0,6)" :key="index2">
                  {{person.name}}
                  <template v-if="item.createTime">
                    <span v-if="person.isRead==1" class="suc">(已读)</span>
                    <span v-else>(未读)</span>
                  </template>
                  <template v-if="index2 !== 5">、</template>
                </span>
              <span class="more suc" @click="item.showAll = true">查看全部&gt;</span>
            </template>
            <template v-else>
              <span v-for="(person,index2) of item.userInfo" :key="index2">
                  {{person.name}}
                  <template v-if="item.createTime">
                    <span v-if="person.isRead==1" class="suc">(已读)</span>
                    <span v-else>(未读)</span>
                  </template>
                  <template v-if="index2 != +item.userCount-1">、</template>
                </span>
            </template>
          </div>
          
          <div class="operator-time">{{item.createTime || item.nowTime}}</div>
          <div  v-if="item.createTime" :class="['user-icon ','i-'+item.read.icon]"></div>
        </template>
        <!-- 抄送人 -->
        <template v-if="item.type==='CC'">
          <div class="title-con">
            <div>
              <span class="operator-name">{{item.nodeName}}</span>
              <span class="user-name"  v-if="item.createTime">已抄送{{ item.userCount }}人<span :class='item.read.color'>({{item.read.text}})</span></span>
              <span class="user-name"  v-else>抄送{{ item.userCount }}人</span>
            </div>
          </div>
          <div class="user-name">
            <template v-if="!item.showAll">
                <span v-for="(person,index2) of item.userInfo.slice(0,6)" :key="index2">
                  {{person.name}}
                  <template v-if="item.createTime">
                    <span v-if="person.isRead==1" class="suc">(已读)</span>
                    <span v-else>(未读)</span>
                  </template>
                  <template v-if="index2 !== 5">、</template>
                </span>
              <span class="more suc" @click="item.showAll = true">查看全部&gt;</span>
            </template>
            <template v-else>
              <span v-for="(person,index2) of item.userInfo" :key="index2">
                  {{person.name}}
                  <template v-if="item.createTime">
                    <span v-if="person.isRead==1" class="suc">(已读)</span>
                    <span v-else>(未读)</span>
                  </template>
                  <template v-if="index2 != +item.userCount-1">、</template>
                </span>
            </template>
          </div>
          <div class="operator-time" v-if="item.createTime">{{item.createTime}}</div>
          <div  v-if="item.createTime" :class="['user-icon ','i-'+item.read.icon]"></div>
        </template>
      </el-timeline-item>
    </el-timeline>
    <!-- 查看图片浮层 -->
     <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "processTimeline",
  props: {
    timeline: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: ""
    }
  },
  methods: {
operatorStatus(type,text) {
      if((type==="APPROVE" &&  text==="审批通过") || (type==="ORSIGNCC" &&  text==="审批通过") ||type==="START" || type==="SIGN"|| type==="COMMENT" || (type==="CC" &&  text==="抄送")){
        return {
          class:'suc',
          line:'',
          text: '审批通过'
        }
      }else if(type==="APPROVE" && text==="审批中"){
        return {
          class:'ing',
          line:'dis',
          text: '审批中'
        }
      }else if(type==="MULTI_APPROVE" && text==="审批中"){
        return {
          class:'ing',
          line:'dis',
          text: '审批中'
        }
      }else if(type==='TRANSFER'){//转交
        return {
          class:'',
          line:'',
          text: ''
        }
      }else if(type==="APPROVE" && text==='驳回'){
        return {
          class:'err',
          line:'err',
          text: '驳回'
        }
      }else{
        return {
          class:'',
          line:'dis',
          text: text
        }
      }
    },
    // 预览图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url
      this.dialogVisible = true
    },
  },
   
}
</script>

<style scoped lang="scss">

.my-timeline /deep/{
  .el-timeline-item__wrapper{
    top: 0;
    padding-left: 70px;
    min-height: 136px;
  }
  .el-timeline-item__tail{
    border-left: 2px solid #00B498;
    left: 27px;
    top: 55px;
    height: calc(100% - 56px);
    opacity: .5;
  }
  .item-process-dis .el-timeline-item__tail{
    border-color: #EDF2F2;
  }
  
  .el-timeline-item__node--large{
    display: block;
      width: 54px;
      height: 54px;
      left: 0;
    .el-timeline-item__icon{
      display: block;
      width: 54px;
      height: 54px;
      border-radius: 8px;
      background-image: url('~@/assets/def_avatar_84px.png');
      background-size: 100%;
    }
    .el-timeline-item__icon.user-photo-CC{
      background-image: url('~@/assets/img/formDesign/icon_chaosong.png');
    }
    .el-timeline-item__icon.user-photo-MULTI_APPROVE,
    .el-timeline-item__icon.user-photo-ORSIGNCC{
      background-image: url('~@/assets/img/formDesign/icon_shenpiren.png');
    }
  }
  .el-timeline-item__timestamp.is-bottom{
    margin-top: 0;
  }
}
.item-process{
  .title-con{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .operator-name{
    font-size: 16px;
    display: inline-block;
    margin-right: 10px;
  }
  .org-name{
    display: inline-block;
    margin-right: 4px;
  }
  .org-name,
  .user-name,
  .cc-count{
    font-size: 14px;
    color: #939696;
  }
  .status{
    color: #939696 ;
    flex-shrink: 0;
    max-width: 100px;
  }
  .cc-status{
    font-size: 14px;
    color: #00B498;
  }
  .user-con{
    font-size: 14px;
    color: #939696;
    margin-bottom: 12px;
    line-height: 22px;
  }
  /* 右边文字的状态 */
  .suc{
    color: #00B498;
  }
  .ing{
    color: #F5C401;
  }
  .err{
    color: #E23C58;
  }
  .dis{
    color: #C5C9C9;
  }
  .operator-con{
    display: flex;
    justify-content: space-between;
  }
  .transfer-user{
    text-align: right;
    font-size: 14px;
    color: #939696;
    margin-top: -12px;
  }
  .operator-time{
    font-size: 14px;
    color: #939696;
    margin-bottom: 12px;
  }
  .new-user{
    color: #939696;
    font-size: 14px;
    line-height: 1;
    margin-top: -10px;
  }
  /* 头像的图标状态 */
  .user-icon{
    width: 16px;
    height: 16px;
    position: absolute;
    top: 38px;
    left: 38px;
    background-size: 100%;
  }
  .i-suc{
    background-image: url('~@/assets/img/icon/icon_wancheng.png');
  }
  .i-zhuanjiao{
    background-image: url('~@/assets/img/icon/icon_zhuanjiao.png');
  }
  .i-zidong{
    background-image: url('~@/assets/img/icon/icon_zidong.png');
  }
  .i-cancel{
    background-image: url('~@/assets/img/icon/icon_chexiao.png');
  }
  .i-ing{
    background-image: url('~@/assets/img/icon/icon_jinxingzhong.png');
  }
  .i-err{
    background-image: url('~@/assets/img/icon/icon_bohui.png');
  }
  .i-unread{
    background-image: url('~@/assets/img/icon/icon_weidu_all.png');
  }
  .i-comment{
    background-image: url('~@/assets/img/icon/icon_pinglun.png');
  }
  .comment{
   background-color: #F8FAFA;
   padding: 12px 8px;
   white-space: normal;
   word-break: break-all;
   color: #A9ABAB;
  }
  .more{
    float: right;
    cursor: pointer;
  }
}

// 评论图片
.img-list{
  display: flex;
  padding-top: 6px;
  .item-img{
    width: 80px;
    height: 80px;
    position: relative;
    cursor: pointer;
    .img{
      display: block;
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
    .preview-bg{
      opacity: 0;
      position: absolute;
      inset:0;
      background-color: rgba($color: #000, $alpha: .5);
      font-size: 20px;
      color: #FFF;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &:hover{
      .preview-bg{
        opacity:1;
        transition: opacity ease .3s;
      }
    }
  }
}

</style>